module.exports = __webpack_public_path__ + "img/dsci0018.00bced30.jpg";